exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h2[data-v-27cd6d22]{font-style:normal}.point-box[data-v-27cd6d22]{width:100%;height:auto;background-color:#025253}.opacity-80[data-v-27cd6d22]{opacity:.8}.negative-top[data-v-27cd6d22]{margin-top:-50px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-27cd6d22","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/PointComponent.vue
// module id = zOMz
// module chunks = 0